/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import ServiceRegistry from "bundle/util/ServiceRegistry";
import HUDServiceBase from "bundle/service/HUDService";

export default class HUDService extends HUDServiceBase {
    hideHud() {
        const appStore = ServiceRegistry.getService("AppStore");
        return new Promise(resolve => {
            if (appStore.isSizedPreset && appStore.previewRef && !appStore.inFullScreen) {
                appStore.previewRef.getPublicApis()
                    .then(apis => {
                        apis.hud.show(false);
                        resolve();
                    });
            } else {
                resolve();
            }
        });
    }

    showHud() {
        const appStore = ServiceRegistry.getService("AppStore");
        return new Promise(resolve => {
            if (appStore.isSizedPreset && appStore.previewRef && !appStore.inFullScreen) {
                appStore.previewRef.getPublicApis()
                    .then(apis => {
                        apis.hud.show(true);
                        resolve();
                    });
            } else {
                resolve();
            }
        });
    }
}
